
Modernizr.on('cssgrid', (result) => {
    if (!result) {
        document.body.classList.add('no-grid');
    }
});
